var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPrizeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121,
    height: 27,
    viewBox: "0 0 121 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#ffc710;font-size:10px;font-family:888-SemiCondensedBold, '888';font-weight:700;}.c{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.126,
    x2: 0.5,
    y2: -0.728,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#005d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248.656 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H121l-7.982,24H6.9Z",
    transform: "translate(248.656 -0.284)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPrizeBg);
export default __webpack_public_path__ + "static/media/topPrizeBg.941b45a39c31026edf9bfa48379d3a2d.svg";
export { ForwardRef as ReactComponent };